import type { ICellRendererParams } from 'ag-grid-community';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useCrmUrl } from '@/utils/crm-url';

import { FertilizationDonorScheduleType } from '../types';

export const DonorName = ({
  value,
  data,
}: ICellRendererParams<FertilizationDonorScheduleType>) => {
  const isNucleusLinkEnabled = useFeatureFlag('Fert_Nucleus_Hyperlinks');
  const crmUrl = useCrmUrl();
  if (isNucleusLinkEnabled) {
    if (!data?.donorScheduleID) {
      return value;
    }

    return (
      <a
        href={`/donor-scheduling?edit=true&id=${data.donorScheduleID}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </a>
    );
  }

  if (!crmUrl) {
    return value;
  }

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10081');
  url.searchParams.set(
    'extraqs',
    'formid=cf94e021-761e-4198-a8e4-61683662691d',
  );
  url.searchParams.set('id', `{${data?.donorScheduleID}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};
